import { render, staticRenderFns } from "./KabNabire.vue?vue&type=template&id=4f613954"
import script from "./KabNabire.vue?vue&type=script&lang=js"
export * from "./KabNabire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports